module.exports = __webpack_public_path__ + "img/inicio.aae8e029.svg";